// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./sketchbook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./sketchbook-tree-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./sketchbook-tree-icon-filled.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./sketchbook-opts-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sketchbook-tab-icon {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.p-TabBar-tabIcon.sketchbook-tree-icon {
    background-color: var(--theia-foreground);
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    width: 19px !important;
    height: var(--theia-icon-size);
    -webkit-mask-size: 100%;
}

.p-mod-current .sketchbook-tree-icon {
    background-color: var(--theia-foreground);
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100%;
}

.sketchbook-trees-container {
    height: 100%;
}

.sketchbook-trees-container .create-new {
    min-height: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
}
/*
By default, theia-button has a left-margin. IDE2 does not need the left margin
for the _New Remote? Sketch_. Otherwise, the button does not fit the default
widget width.
*/
.sketchbook-trees-container .create-new .theia-button {
    margin-left: unset;
}

.sketchbook-tree__opts {
    background-color: var(--theia-foreground);
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    -webkit-mask-position: center;
    -webkit-mask-repeat: no-repeat;
    width: var(--theia-icon-size);
    height: var(--theia-icon-size);
}

.active-sketch {
    font-weight: 500;
    background-color: var(--theia-list-activeSelectionBackground) !important;
    color: var(--theia-list-activeSelectionForeground) !important;
}

#arduino-sketchbook-tree-widget .theia-TreeNode {
    line-height: 30px;
}

#arduino-sketchbook-tree-widget .theia-TreeNodeSegmentGrow {
    flex: 1;
}

.theia-TreeNode .sketchbook-commands-icons {
    display: none;
}

.theia-TreeNode:hover .sketchbook-commands-icons,
.theia-TreeNode.theia-mod-selected .sketchbook-commands-icons {
    display: block;
}

.theia-Tree:focus .theia-TreeNode.theia-mod-selected,
.theia-Tree .ReactVirtualized__List:focus .theia-TreeNode.theia-mod-selected {
    background: var(--theia-list-inactiveSelectionBackground);
    color: var(--theia-list-inactiveSelectionForeground) !important;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/sketchbook.css"],"names":[],"mappings":"AAAA;IACI,qDAAqC;IACrC,6CAA6B;AACjC;;AAEA;IACI,yCAAyC;IACzC,qDAA6C;IAC7C,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,yCAAyC;IACzC,qDAAoD;IACpD,6BAA6B;IAC7B,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;;;;CAIC;AACD;IACI,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,qDAA6C;IAC7C,6BAA6B;IAC7B,8BAA8B;IAC9B,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,wEAAwE;IACxE,6DAA6D;AACjE;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,yDAAyD;IACzD,+DAA+D;AACnE","sourcesContent":[".sketchbook-tab-icon {\r\n    -webkit-mask: url(\"./sketchbook.svg\");\r\n    mask: url(\"./sketchbook.svg\");\r\n}\r\n\r\n.p-TabBar-tabIcon.sketchbook-tree-icon {\r\n    background-color: var(--theia-foreground);\r\n    -webkit-mask: url(./sketchbook-tree-icon.svg);\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-repeat: no-repeat;\r\n    width: 19px !important;\r\n    height: var(--theia-icon-size);\r\n    -webkit-mask-size: 100%;\r\n}\r\n\r\n.p-mod-current .sketchbook-tree-icon {\r\n    background-color: var(--theia-foreground);\r\n    -webkit-mask: url(./sketchbook-tree-icon-filled.svg);\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-repeat: no-repeat;\r\n    -webkit-mask-size: 100%;\r\n}\r\n\r\n.sketchbook-trees-container {\r\n    height: 100%;\r\n}\r\n\r\n.sketchbook-trees-container .create-new {\r\n    min-height: 58px;\r\n    height: 58px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n/*\r\nBy default, theia-button has a left-margin. IDE2 does not need the left margin\r\nfor the _New Remote? Sketch_. Otherwise, the button does not fit the default\r\nwidget width.\r\n*/\r\n.sketchbook-trees-container .create-new .theia-button {\r\n    margin-left: unset;\r\n}\r\n\r\n.sketchbook-tree__opts {\r\n    background-color: var(--theia-foreground);\r\n    -webkit-mask: url(./sketchbook-opts-icon.svg);\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-repeat: no-repeat;\r\n    width: var(--theia-icon-size);\r\n    height: var(--theia-icon-size);\r\n}\r\n\r\n.active-sketch {\r\n    font-weight: 500;\r\n    background-color: var(--theia-list-activeSelectionBackground) !important;\r\n    color: var(--theia-list-activeSelectionForeground) !important;\r\n}\r\n\r\n#arduino-sketchbook-tree-widget .theia-TreeNode {\r\n    line-height: 30px;\r\n}\r\n\r\n#arduino-sketchbook-tree-widget .theia-TreeNodeSegmentGrow {\r\n    flex: 1;\r\n}\r\n\r\n.theia-TreeNode .sketchbook-commands-icons {\r\n    display: none;\r\n}\r\n\r\n.theia-TreeNode:hover .sketchbook-commands-icons,\r\n.theia-TreeNode.theia-mod-selected .sketchbook-commands-icons {\r\n    display: block;\r\n}\r\n\r\n.theia-Tree:focus .theia-TreeNode.theia-mod-selected,\r\n.theia-Tree .ReactVirtualized__List:focus .theia-TreeNode.theia-mod-selected {\r\n    background: var(--theia-list-inactiveSelectionBackground);\r\n    color: var(--theia-list-inactiveSelectionForeground) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
